import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { keyframes } from '@mui/system';
import { PRIMARY_BLUE } from '../../theme';

const pulse = keyframes`
  0%, 100% { transform: scale(1); opacity: 1; }
  50%       { transform: scale(1.08); opacity: 0.75; }
`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`;

export default function ReportPending({ tr }) {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            py: 12,
            gap: 3,
        }}>
            {/* Icon area */}
            <Box sx={{ position: 'relative', width: 96, height: 96 }}>
                {/* Outer ring — spinning */}
                <Box sx={{
                    position: 'absolute',
                    inset: 0,
                    borderRadius: '50%',
                    border: `3px solid transparent`,
                    borderTopColor: PRIMARY_BLUE,
                    borderRightColor: `${PRIMARY_BLUE}33`,
                    animation: `${spin} 1.4s linear infinite`,
                }} />
                {/* Inner circle — pulsing */}
                <Box sx={{
                    position: 'absolute',
                    inset: 10,
                    borderRadius: '50%',
                    bgcolor: `${PRIMARY_BLUE}12`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    animation: `${pulse} 2s ease-in-out infinite`,
                }}>
                    {/* Hourglass SVG inline */}
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M6 2h12v4l-4 4 4 4v4H6v-4l4-4-4-4V2z"
                            stroke={PRIMARY_BLUE}
                            strokeWidth="1.8"
                            strokeLinejoin="round"
                            fill="none"
                        />
                        <path
                            d="M6 18h12"
                            stroke={PRIMARY_BLUE}
                            strokeWidth="1.8"
                            strokeLinecap="round"
                        />
                        <path
                            d="M9 6h6"
                            stroke={PRIMARY_BLUE}
                            strokeWidth="1.8"
                            strokeLinecap="round"
                        />
                        <path
                            d="M12 14l-2 2h4l-2-2z"
                            fill={PRIMARY_BLUE}
                            stroke="none"
                        />
                    </svg>
                </Box>
            </Box>

            {/* Texto */}
            <Box sx={{ textAlign: 'center', maxWidth: 360 }}>
                <Typography sx={{
                    fontSize: '20px',
                    fontWeight: 600,
                    letterSpacing: '-0.4px',
                    lineHeight: '28px',
                    color: 'text.primary',
                    mb: 1,
                }}>
                    {tr('report_pending_title')}
                </Typography>
                <Typography sx={{
                    fontSize: '13px',
                    fontWeight: 400,
                    letterSpacing: '-0.07px',
                    lineHeight: '20px',
                    color: 'text.secondary',
                }}>
                    {tr('report_pending_description')}
                </Typography>
            </Box>

            {/* Dots de actividad */}
            <Box sx={{ display: 'flex', gap: 0.75 }}>
                {[0, 1, 2].map((i) => (
                    <Box key={i} sx={{
                        width: 6,
                        height: 6,
                        borderRadius: '50%',
                        bgcolor: PRIMARY_BLUE,
                        animation: `${pulse} 1.2s ease-in-out ${i * 0.2}s infinite`,
                    }} />
                ))}
            </Box>
        </Box>
    );
}
